import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { formService } from '@/services/form.service';
import type { FormUpdateRequest } from '@/types/form';

export const useForm = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FORM, churchId],
    queryFn: () => formService.getForm(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useUpdateFormMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: FormUpdateRequest) => formService.updateForm(churchId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FORM, churchId] });
      showNotification({ title: 'Success', message: 'Form updated successfully', color: 'green' });
    },
  });
};
